import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { MenuItem, Table, TextField, TablePagination } from "@material-ui/core";
import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Skeleton from "@mui/material/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import * as Actions from "../../store/action/claimManagement";
import { AiOutlineEye } from "react-icons/ai";
import { BsThreeDots } from "react-icons/bs";
import ReplacementCarInfo from "./ReplacementCarInfo";
import "./ReplacementCar.css";
import DialogActions from "@material-ui/core/DialogActions";
import { translateReplacementCarStatus } from "../../utils/translateReplacementCarStatus";
import PreviewButtonPopup from "../../components/TaskListSection/PreviewButtonPopup";
 
import exportToExcel from '../../utils/convertJsonToExcel.js';

// Add sorting helper functions
function desc(a, b, orderBy) {
  if (!a[orderBy] && !b[orderBy]) return 0;
  if (!a[orderBy]) return 1;
  if (!b[orderBy]) return -1;
  
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "85vh",
  },
  tableCellSmall: {
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "21px",
    color: "rgba(70, 78, 95, 1)",
    borderBottom: "1px solid  rgba(0, 0, 0, 0.08)",
  },
  paper: {
    width: "100%",
    borderRadius: "11px",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },
  tableWrapper: {
    padding: "40px",
  },
  tableHeadRows: {
    whiteSpace: "nowrap",
    fontFamily: "Poppins",
    fontWeight: 600,
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(181, 181, 195, 1)",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    padding: "1%",
  },

  tableSortLabel: {
    color: "rgba(32, 29, 35, 1)",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: 12,
    lineHeight: "18px",
  },
  titre: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 600,
    color: "rgba(63, 66, 84, 1)",
  },
  titreLabel: {
    fontFamily: "Poppins",
    fontSize: 12,
    fontWeight: 400,
    color: "rgba(32, 18, 70, 1)",
  },
  tablePagination: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    color: "rgba(32, 18, 70, 1)",
  },
  dateRangeContainer: {
    display: "flex",
    alignItems: "center",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    borderRadius: 5,
    padding: "5px 10px",
  },
  dateContainer: {
    border: "none",
    outline: "none",
    background: "transparent",
    borderRadius: 5,
    fontFamily: "Poppins",
    paddingLeft: "5px",
  },
  inputContainer: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  viewBtn: {
    width: "40px",
    height: "34px",
    borderRadius: "6px",
    backgroundColor: "rgba(240, 243, 199, 1)",
    border: 0,
    lineHeight: "18px",
    color: "rgba(187, 200, 8, 1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  taskNameColumn: {
    width: "114px",
    height: "20px",
    gap: "0px",
    fontFamily: "Poppins",
    fontSize: "10.17px",
    fontWeight: 500,
    textAlign: "left",
    color: "rgba(187, 200, 8, 1)",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  tableContent: {
    fontFamily: "Inter",
    fontSize: 14,
    fontWeight: 400,
    //lineHeight: 19.6,
    textAlign: "left",
    color: "rgba(32, 29, 35, 0.8)",
    paragraph: {
      lineHeight: "32.69px",
    },
  },
  sinistres: {
    fontFamily: "Poppins",
    fontSize: 14,
    fontWeight: 600,
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  dropdownMenu: {
    position: "absolute",
    zIndex: 1,
    backgroundColor: "white",
    border: "0.61px solid rgba(226, 217, 239, 1)",
    //boxShadow: theme.shadows[5],
    marginRight: "110px",
    borderRadius: 6,
  },
  dropdownItem: {
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  naText: {
    color: "rgb(145, 145, 145)",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    backgroundColor: "rgba(255, 255, 255, 1)",
    border: "none",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
    padding: theme.spacing(2, 4, 3),
    width: "459px",
    height: "175px",
  },
  modalTitle: {
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: 500,
    lineHeight: "21px",
    textAlign: "left",
    marginBottom: "16px",
  },
  // dialogTitle: {
  //   fontFamily: "Poppins",
  //   fontWeight: 500,
  //   fontSize: 15,
  //   color: "rgba(63, 66, 84, 1)",
  //   backgroundColor: "white",
  //   borderBottom: "1px solid #E5EAEE",
  // },
  line: {
    height: "2px",
    backgroundColor: "rgba(243, 246, 249, 1)",
    width: "100%",
    marginBottom: "16px",
  },
  selectModal: {
    width: "400px",
    height: "36px",
    borderRadius: "4px",
    border: "1px solid rgba(222, 222, 222, 1)",
  },
  CancelStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    color: "rgb(255, 54, 54)",
    backgroundColor: " rgb(255, 229, 229)",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  ajouterStyle: {
    marginLeft: "20px",
    width: "62px",
    height: "26px",
    backgroundColor: "rgba(187, 200, 8, 1)",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "5.38px",
    fontFamily: "Poppins",
    fontSize: "10.76px",
    fontWeight: 600,
    border: 0,
  },
  TextContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "10px 15px",
  },
  dialogContent: {
    overflowY: "auto",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
  cardText: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(128, 128, 143, 1)",
  },
  cardValue: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    color: "rgba(24, 28, 50, 1)",
    textAlign: "Right",
  },
  styleInput: {
    fontFamily: "Poppins",
    fontSize: "13px",
    fontWeight: 500,
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    color: "rgba(24, 28, 50, 0.58)",
    lineHeight: "21px",
    textAlign: "Right",
    padding: "5px",
    width: "240px",
    height: "30px",
    borderRadius: "4px",
  },
  card: {
    backgroundColor: "white",
    borderRadius: "8px",
    width: "100%",
    height: "680px",
    border: "0.61px solid rgba(226, 217, 239, 1)",
  },
  dialogPaper: {
    width: "700px",
    overflow: "hidden",
  },
  selectInput: {
    border: "0.61px solid rgba(226, 217, 239, 1)",
    background: "rgba(255, 255, 255, 1)",
    width: "148px",
    height: "29.69px",
    borderRadius: 5,
    marginLeft: "20px",
  },
  selectInputDialog: {
    width: "240px",
    border: "0",
    padding: "5px",
    background: "rgba(243, 246, 249, 1)",
    height: "29.69px",
    borderRadius: 5,
  },
  optionLabel: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
  },
  dialogTitle: {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: 15,
    color: "rgba(63, 66, 84, 1)",
    backgroundColor: "white",
    borderBottom: "1px solid #E5EAEE",
  },
  optionItem: {
    width: "150px",
    padding: theme.spacing(1),
    cursor: "pointer",
    backgroundColor: "white",
    color: "rgba(32, 18, 70, 1)",
    fontFamily: "Poppins",
    fontSize: "10px",
    fontWeight: 400,
    textAlign: "left",
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export default function ReplacementCarList(props) {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [selected, setSelected] = useState([]);
  const [inputType, setInputType] = useState("text"); // (for date field)
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { replacementCarRequestsData, loading } = useSelector(
    (state) => state.replacementCarRequestsReducer
  );
  const [dateRange, setDateRange] = useState({ fromDate: "", toDate: "" });
  const [claimNumber, setClaimNumber] = useState("");
  const [filteredReplacementCarRequests, setFilteredReplacementCarRequests] =
    useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [rejectionMotif, setRejectionMotif] = useState("");
  // Add sorting state
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("createdAt");

  const [replacementCar, setReplacementCar] = useState({});
  const [open, setOpen] = useState(false);
  const today = new Date();
  const handleClose = () => {
    setOpen(false);
  };
  const [previewOpen, setPreviewOpen] = useState(false);
  const [selectedClaimNumber, setSelectedClaimNumber] = useState(null);

  // Add request sort handler
  const handleRequestSort = (event, property) => {
    const isDesc = orderBy === property && order === "desc";
    setOrder(isDesc ? "asc" : "desc");
    setOrderBy(property);
  };

  const handleClosePreview = () => {
    setPreviewOpen(false);
  };

  const handlePreviewClick = (claimNumber) => {
    setSelectedClaimNumber(claimNumber);
    console.log("claimNumber", claimNumber);
    setPreviewOpen(true);
  };

  // Create a TableHead component
  function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } = props;
    
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };
    
    return (
      <tr>
        {headRows.map((row) => (
          <TableCell
            key={row.id}
            align={row.align}
            sortDirection={orderBy === row.id ? order : false}
            className={classes.tableHeadRows}
          >
            <TableSortLabel
              active={true}
              direction={orderBy === row.id ? order : "asc"}
              onClick={createSortHandler(row.id)}
              style={{
                whiteSpace: "nowrap",
                fontFamily: "Poppins",
                fontWeight: 600,
                fontSize: 12,
                lineHeight: "18px",
                color: "rgba(181, 181, 195, 1)",
              }}
            >
              {row.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </tr>
    );
  }

  const headRows = [
    {
      id: "requestNumber",
      align: "center",
      label: "N° Demande",
      width: "15%",
    },
    {
      id: "createdAt",
      align: "center",
      label: "Date de création",
      width: "15%",
    },
    {
      id: "repairStartDate",
      align: "center",
      label: "Date Debut réparation",
      width: "15%",
    },
    {
      id: "immobilizationDuration",
      align: "center",
      label: "Immobilisation",
      width: "15%",
    },
    {
      id: "dueDate",
      align: "center",
      label: "Fin réparation",
      width: "15%",
    },
    {
      id: "replacementCarApprovalDate",
      align: "center",
      label: "Date accord",
      width: "15%",
    },
    {
      id: "numberOfGrantedDays",
      align: "center",
      label: "Jours accordés",
      width: "15%",
    },
    {
      id: "replacementStatus",
      align: "center",
      label: "Statut",
      width: "15%",
    },
    {
      id: "",
      align: "left",
      label: "",
      width: "15%",
    },
  ];

  function getDateFromString(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${day}/${month}/${year}`;
    // return `${year}-${month}-${day}`;
  }

  const calculateEstimatedCompletionDate = (
    startDate,
    immobilizationDuration
  ) => {
    if (!startDate) return "N/A";
    const start = new Date(startDate);
    start.setDate(start.getDate() + immobilizationDuration);
    return start.toISOString().split("T")[0];
  };
  const filterRequests = () => {
    let filteredRequests = replacementCarRequestsData;

    if (dateRange.fromDate) {
      filteredRequests = filteredRequests.filter(
        (request) =>
          new Date(request.replacementCarApprovalDate) >=
          new Date(dateRange.fromDate)
      );
    }

    if (dateRange.toDate) {
      filteredRequests = filteredRequests.filter(
        (request) =>
          new Date(request.replacementCarApprovalDate) <=
          new Date(dateRange.toDate)
      );
    }

    if (claimNumber) {
      filteredRequests = filteredRequests.filter((request) =>
        request.associatedClaimNumber.includes(claimNumber)
      );
    }

    if (selectedStatus) {
      filteredRequests = filteredRequests.filter(
        (request) => request.replacementStatus === selectedStatus
      );
    }

    setFilteredReplacementCarRequests(filteredRequests);
  };

  function renderField(field) {
    return field ? field : <span className={classes.naText}>N/A</span>;
  }
  const handleDateChange = (e, type) => {
    const dateValue = e.target.value;
    if (type === "from") {
      setDateRange((prevState) => ({ ...prevState, fromDate: dateValue }));
    } else {
      setDateRange((prevState) => ({ ...prevState, toDate: dateValue }));
    }
    filterRequests(); // Call filtering logic after updating the date
  };
  useEffect(() => {
    filterRequests();
  }, [replacementCarRequestsData, dateRange, claimNumber, selectedStatus]);

  const handleClaimNumberChange = (e) => {
    setClaimNumber(e.target.value);
    filterRequests(); // Call filtering logic after updating the claim number
  };
  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
    filterRequests(); // Trigger filtering when status changes
  };

  const getAllReplacementCar = () => {
    return dispatch(Actions.getReplacementCarRequests());
  };

  const handleEditClick = (replacementCar) => {
    if (replacementCar) {
      setReplacementCar(replacementCar);
      setOpen(true);
    }
  };

  useEffect(() => {
    getAllReplacementCar();
  }, [dispatch]);

  useEffect(() => {
    if (!loading) {
      setFilteredReplacementCarRequests(replacementCarRequestsData);
    }
  }, [loading, replacementCarRequestsData]);
  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedReplacementCarRequest = {
      ...replacementCar,
      rejectionMotif:
        replacementCar.replacementStatus === "REJECTED" ? rejectionMotif : null,
    };

    updateReplacementCar(replacementCar._id, updatedReplacementCarRequest)
      .then(() => {
        setFilteredReplacementCarRequests([]);
        getAllReplacementCar();
        handleClose();
      })
      .catch((error) => {
        console.error("Failed to update:", error);
        handleClose();
      });
  };

  const updateReplacementCar = (
    replacementCarRequestId,
    replacementCarRequest
  ) => {
    return dispatch(
      Actions.updateReplacementCarRequest(
        replacementCarRequestId,
        replacementCarRequest
      )
    );
  };

  const handleStatusDialogChange = (status) => {
    setReplacementCar((prevReplacementCar) => ({
      ...prevReplacementCar,
      replacementStatus: status,
    }));

    if (status !== "REJECTED") {
      setRejectionMotif("");
    }
  };
  function convertToDayMonthYear(dateString) {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
}
  const handleRejectionMotifChange = (e) => {
    setRejectionMotif(e);
  };
  function handleExport() {
    console.log("filteredReplacementCarRequests : " + JSON.stringify(filteredReplacementCarRequests));
    
    if (!Array.isArray(filteredReplacementCarRequests)) {
        console.error("filteredReplacementCarRequests is not an array");
        return;
    }

    const dataExportToExcel = filteredReplacementCarRequests.map(data => {
        // Calculate the repair end date based on the repair start date and immobilization duration
        let repairEndDate = new Date(data.repairStartDate);
        repairEndDate.setDate(repairEndDate.getDate() + data.immobilizationDuration);

        return {
            "N° Demande": data.requestNumber || null,
            "Num Sinistre": data.associatedClaimNumber || null,
            "Date Debut réparation": getDateFromString(data.repairStartDate) || null,
            "Immobilisation": data.immobilizationDuration || null,
            "Fin réparation":data.repairStartDate &&  data.immobilizationDuration  ? getDateFromString(repairEndDate) : null, // Use the calculated repair end date
            "Date accord": getDateFromString(data.replacementCarApprovalDate) || null,
            "Jours accordés": data.numberOfGrantedDays || null,
            "Statut": translateReplacementCarStatus(data.replacementStatus) || null
        };
    });

    exportToExcel(dataExportToExcel, 'ReplacementCars.xlsx');
}

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div className={classes.root}>
      <ReplacementCarInfo
        replacementCarRequestsData={replacementCarRequestsData}
        loading={loading}
      />
      <Paper className={classes.paper}>
        <div className={classes.tableWrapper}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "40px",
            }}
          >
            <div className={classes.titre} style={{ width: "18%" }}>
              Liste des demande de VR
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "80%",
                justifyContent: "space-between",
              }}
            >
              <div
                className={classes.titre}
                style={{ marginRight: "15px", whiteSpace: "nowrap" }}
              >
                Filtrer par
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "15px",
                }}
              >
                Date
                <div
                  className={classes.dateRangeContainer}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "15px",
                    height: "29px",
                  }}
                >
                  <span style={{ marginRight: "5px" }}>De</span>
                  <input
                    type={inputType}
                    className={classes.dateContainer}
                    placeholder=""
                    onFocus={() => setInputType("date")}
                    onBlur={() => setInputType("text")}
                    style={{ width: "110px", height: "29px" }}
                    onChange={(e) => handleDateChange(e, "from")}
                  />
                  <span style={{ marginRight: "1px" }}>A</span>
                  <input
                    type={inputType}
                    className={classes.dateContainer}
                    placeholder=""
                    onFocus={() => setInputType("date")}
                    onBlur={() => setInputType("text")}
                    style={{ width: "110px", height: "29px" }}
                    onChange={(e) => handleDateChange(e, "to")}
                  />
                </div>
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  whiteSpace: "nowrap",
                }}
              >
                N° Sinistre
                <input
                  type="text"
                  className={classes.inputContainer}
                  style={{ width: "120px", marginLeft: "10px" }}
                  onChange={handleClaimNumberChange}
                  list="claimNumbers"
                />
              </div>
              <div
                className={classes.titreLabel}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "10px",
                }}
              >
                Statut
                <select
                  className={classes.selectInput}
                  value={selectedStatus}
                  onChange={handleStatusChange}
                >
                  <option className={classes.optionItem} value=""></option>
                  <option className={classes.optionItem} value="PENDING">
                    En Cours
                  </option>
                  <option className={classes.optionItem} value="APPROVED">
                    Accepté
                  </option>
                  <option className={classes.optionItem} value="REJECTED">
                    Refusé
                  </option>
                  <option className={classes.optionItem} value="CANCELLED">
                    Annulé
                  </option>
                </select>
              </div>
              {/* <button
                style={{
                  border: "0.96px solid rgba(187, 200, 8, 1)",
                  color: "rgba(187, 200, 8, 1)",
                  width: "64px",
                  height: "27px",
                  fontFamily: "Poppins",
                  fontSize: "12.76px",
                  fontWeight: 400,
                  lineHeight: "19.14px",
                  background: "rgba(255, 255, 255, 1)",
                }}
                onClick={handleExport}
              >
                Export
              </button> */}
            </div>
          </div>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
          >
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            {loading ? (
              <>
                {[...Array(10)].map((row, index) => {
                  return (
                    <tr hover style={{ height: "48px" }}>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableCellSmall}
                      >
                        <Skeleton animation="wave" />
                      </TableCell>
                      <TableCell
                        align="right"
                        className={classes.tableCellSmall}
                      >
                        <button className={classes.viewBtn}>
                          <BsThreeDots />
                        </button>
                        <button
                          className={classes.viewBtn}
                          style={{ marginLeft: "7px" }}
                        >
                          <AiOutlineEye />
                        </button>
                      </TableCell>
                    </tr>
                  );
                })}
              </>
            ) : (
              <>
                {filteredReplacementCarRequests.length > 0 ? (
                  <>
                    {stableSort(filteredReplacementCarRequests, getSorting(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map(
                      (replacementCar, index) => {
                        const repairEndDate = new Date(
                          replacementCar.repairStartDate
                        );
                        repairEndDate.setDate(
                          repairEndDate.getDate() +
                            replacementCar.immobilizationDuration
                        );
                        return (
                          <tr
                            key={replacementCar._id || index} // Ensure this key is unique
                            hover
                            style={{
                              height: "50px",
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              <div style={{ display: "flex" }}>
                                <div style={{ width: "50%" }}>
                                  {renderField(replacementCar.requestNumber)}
                                </div>
                                <div
                                  style={{
                                    height: "26px",
                                    borderRadius: "51px",
                                    background: "rgba(240, 243, 199, 1)",
                                    textAlign: "center",
                                    padding: "5px",
                                    fontFamily: "Poppins",
                                    fontSize: "10.69px",
                                    fontWeight: 600,
                                    lineHeight: "16.03px",
                                    color: "rgba(187, 200, 8, 1)",
                                    cursor: "pointer", 
                                  }}
                                  onClick={() =>
                                    handlePreviewClick(
                                      replacementCar.associatedClaimNumber
                                    )
                                  } 
                                >
                                  {renderField(
                                    replacementCar.associatedClaimNumber
                                  )}
                                </div>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              <div style={{ display: "flex" }}>
                                <div style={{ width: "50%" }}>
                                  {renderField(getDateFromString(replacementCar.createdAt))}
                                </div>
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              {renderField(
                                getDateFromString(
                                  replacementCar.repairStartDate
                                )
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              {renderField(
                                replacementCar.immobilizationDuration
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              {renderField(getDateFromString(repairEndDate))}
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              {renderField(
                                getDateFromString(
                                  replacementCar.replacementCarApprovalDate
                                )
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              {renderField(
                                
                                  replacementCar.numberOfGrantedDays
                                
                              )}
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              <div
                                style={{
                                  display: "inline-block",
                                  width: "80px",
                                  textAlign: "center",
                                  padding: "5px",
                                  borderRadius: "51px",
                                  border: 0,
                                  fontFamily: "Poppins",
                                  fontSize: "10.69px",
                                  fontWeight: 600,
                                  lineHeight: "16.03px",
                                  color:
                                    replacementCar.replacementStatus ===
                                    "APPROVED"
                                      ? "rgba(187, 200, 8, 1)"
                                      : replacementCar.replacementStatus ===
                                          "REJECTED" ||
                                        replacementCar.replacementStatus ===
                                          "CANCELLED"
                                      ? "rgba(255, 54, 54, 1)"
                                      : replacementCar.replacementStatus ===
                                        "PENDING"
                                      ? "rgba(187, 200, 8, 1)"
                                      : "rgba(0, 0, 0, 1)",
                                  backgroundColor:
                                    replacementCar.replacementStatus ===
                                    "APPROVED"
                                      ? "rgba(240, 243, 199, 1)"
                                      : replacementCar.replacementStatus ===
                                          "REJECTED" ||
                                        replacementCar.replacementStatus ===
                                          "CANCELLED"
                                      ? "rgba(255, 229, 229, 1)"
                                      : replacementCar.replacementStatus ===
                                        "PENDING"
                                      ? "rgba(240, 243, 199, 1)"
                                      : "rgba(240, 240, 240, 1)",
                                }}
                              >
                                {translateReplacementCarStatus(
                                  replacementCar.replacementStatus
                                )}
                              </div>
                            </TableCell>

                            <TableCell
                              align="left"
                              className={classes.tableCellSmall}
                            >
                              <button
                                style={{
                                  width: "61px",
                                  height: "34px",
                                  borderRadius: "6px",
                                  background: "rgba(187, 200, 8, 1)",
                                  border: 0,
                                  fontFamily: "Poppins",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  lineHeight: "18px",
                                  color: "rgba(255, 255, 255, 1)",
                                }}
                                onClick={() => handleEditClick(replacementCar)}
                              >
                                Modifier
                              </button>
                            </TableCell>
                          </tr>
                        );
                      }
                    )}
                  </>
                ) : (
                  <>
                    <tr>
                      <td colSpan={9}>
                        <div
                          style={{
                            fontFamily: "Poppins",
                            fontWeight: 400,
                            fontSize: 15,
                            lineHeight: "22.5px",
                            color: "rgba(70, 78, 95, 1)",
                            padding: "20px",
                            textAlign: "center"
                          }}
                        >
                          Aucune demande de véhicule de remplacement n'est trouvée
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </>
            )}
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 20, 30]}
            component="div"
            count={filteredReplacementCarRequests.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            style={{
              fontFamily: "Poppins",
              fontSize: "12px",
              fontWeight: 400,
              lineHeight: "18px",
              color: "rgba(32, 18, 70, 1)",
            }}
            labelRowsPerPage="Lignes par page"
          />
        </div>
      </Paper>
    
      <Dialog
        open={open}
        onClose={handleClose}
        classes={{ paper: classes.dialogPaper }}
        maxWidth={false}
      >
        <DialogTitle
          className={classes.dialogTitle}
          style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}
        >
          {replacementCar ? replacementCar.requestNumber : "No Request Number"}
        </DialogTitle>

        <form onSubmit={handleSubmit}>
          <DialogContent className={classes.dialogContent}>
            <div className={classes.TextContainer}>
              <div className={classes.cardText}>Date d'entrée du Véhicule</div>
              <div className={classes.cardValue}>
                <input
                  disabled
                  className={classes.styleInput}
                  type="text"
                  value={calculateEstimatedCompletionDate(
                    replacementCar.repairStartDate,
                    0
                  )}
                />
              </div>
            </div>
            <div className={classes.TextContainer}>
              <div className={classes.cardText}>Durée Immobilisation</div>
              <div className={classes.cardValue}>
                <input
                  disabled
                  className={classes.styleInput}
                  type="text"
                  value={`${replacementCar.immobilizationDuration} Jours`}
                />
              </div>
            </div>
            <div className={classes.TextContainer}>
              <div className={classes.cardText}>Date Sorite du Véhicule</div>
              <div className={classes.cardValue}>
                <input
                  disabled
                  className={classes.styleInput}
                  type="text"
                  value={calculateEstimatedCompletionDate(
                    replacementCar.repairStartDate,
                    replacementCar.immobilizationDuration
                  )}
                />
              </div>
            </div>
            <div className={classes.TextContainer}>
              <div className={classes.cardText}>Statut</div>
              <select
                className={classes.selectInputDialog}
                value={replacementCar.replacementStatus}
                onChange={(e) => handleStatusDialogChange(e.target.value)}
              >
                <option className={classes.optionItem} value={"PENDING"}>
                  En Cours
                </option>
                <option className={classes.optionItem} value={"REJECTED"}>
                  Refusé
                </option>
                <option className={classes.optionItem} value={"CANCELLED"}>
                  Annulé
                </option>
                <option className={classes.optionItem} value={"APPROVED"}>
                  Accepté
                </option>
              </select>
            </div>
            {replacementCar.replacementStatus === "REJECTED" && (
              <div className={classes.TextContainer}>
                <div className={classes.cardText}>Motif de Rejet</div>

                <select
                  className={classes.selectInputDialog}
                  value={replacementCar.rejectionMotif}
                  onChange={(e) => handleRejectionMotifChange(e.target.value)}
                >
                  <option
                    className={classes.optionItem}
                    value={"Usage commercial"}
                  >
                    Usage commercial
                  </option>
                  <option
                    className={classes.optionItem}
                    value={"Durée d'immobilisation inférieure à 24 heures"}
                  >
                    Durée d'immobilisation inférieure à 24 heures
                  </option>
                  <option
                    className={classes.optionItem}
                    value={"Plafond atteint"}
                  >
                    Plafond atteint
                  </option>
                </select>
              </div>
            )}
             
            {replacementCar.replacementStatus === "APPROVED" && (
                <><div className={classes.TextContainer}>
                <div className={classes.cardText}>Nombre de Jours Accordés</div>
                <div className={classes.cardValue}>
                  <input
                    placeholder="Jours"
                    className={classes.styleInput}
                    type="Number"
                    value={replacementCar.numberOfGrantedDays || ""} 
                    onChange={(e) =>
                      setReplacementCar({
                        ...replacementCar,
                        numberOfGrantedDays: e.target.value,
                      })
                    } 
                  />
                </div>
              </div>
              
              <div className={classes.TextContainer}>
                  <div className={classes.cardText}>Date d'accord de la VR</div>
                  <div className={classes.cardValue}>
                    <input
                      className={classes.styleInput}
                      type="date"
                      name="replacementCarApprovalDate"
                      value={replacementCar.replacementCarApprovalDate
                        ? new Date(replacementCar.replacementCarApprovalDate)
                          .toISOString()
                          .split("T")[0]
                        : ""}
                      onChange={(e) => setReplacementCar({
                        ...replacementCar,
                        replacementCarApprovalDate: e.target.value,
                      })}
                      required />
                  </div>
                </div></>
            )}

            <div className={classes.TextContainer}>
              <div className={classes.cardText}>Commentaire</div>
              <br />
              <div className={classes.cardValue}>
                <textarea
                  className={classes.styleInput}
                  placeholder={replacementCar.comment}
                  style={{ width: "240px", textAlign: "left", height: "100px" }}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions style={{ backgroundColor: "rgba(243, 246, 249, 1)" }}>
            <button className={classes.CancelStyle} onClick={handleClose}>
              Annuler
            </button>
            <button
              className={classes.ajouterStyle}
              type="submit"
              disabled={
                (replacementCar.replacementStatus === "APPROVED" &&
                  !replacementCar.replacementCarApprovalDate) ||
                (replacementCar.replacementStatus === "REJECTED" &&
                  !rejectionMotif)
              }
            >
              Valider
            </button>
          </DialogActions>
        </form>
      </Dialog>
      {previewOpen && (     
      <PreviewButtonPopup
        open={previewOpen}
        onClose={handleClosePreview}
        infoSinistre={selectedClaimNumber}
      />
      )}
    </div>
    
  );
}
